import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { DIRECTIONS } from './_constants';

export const CaretOutlinedIcon = ({
  width,
  height,
  fill,
  className,
  direction,
  ...rest
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='64 64 896 896'
      width={width}
      height={height}
      className={clsx('icon', 'icon-cart-outlined', className, {
        'icon-cart-outlined--up': direction === DIRECTIONS.UP,
        'icon-cart-outlined--right': direction === DIRECTIONS.RIGHT,
        'icon-cart-outlined--down': direction === DIRECTIONS.DOWN,
        'icon-cart-outlined--left': direction === DIRECTIONS.LEFT
      })}
      {...rest}
    >
      <path
        fill={fill}
        d='M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'
      />
    </svg>
  );
};

CaretOutlinedIcon.defaultProps = {
  width: 15,
  height: 15,
  fill: 'currentColor',
  className: '',
  direction: 'up'
};

CaretOutlinedIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  direction: PropTypes.oneOf(Object.values(DIRECTIONS))
};
